import React from 'react'
import PropTypes from 'prop-types'
import { Box, IconButton, TextField, Tooltip } from '@material-ui/core'
import { X as CancelIcon, Send as SendIcon } from 'react-feather'
import useStyles from './styles'

const CommentReplyForm = ({
  value,
  onChange,
  onSubmit,
  onCancel,
  disabled,
}) => {
  const classes = useStyles()

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      onSubmit()
    }
  }

  return (
    <Box className={classes.replyRow} mt={1}>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Responder comentário... (Enter para enviar)"
        variant="outlined"
        size="small"
        fullWidth
        multiline
        autoFocus
        disabled={disabled}
      />
      <Tooltip title="Enviar">
        <span>
          <IconButton
            size="small"
            color="primary"
            onClick={onSubmit}
            disabled={!value.trim() || disabled}
          >
            <SendIcon size={18} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Cancelar">
        <IconButton size="small" onClick={onCancel}>
          <CancelIcon size={16} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

CommentReplyForm.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

CommentReplyForm.defaultProps = {
  disabled: false,
}

export default CommentReplyForm
